import { Pipe, PipeTransform } from '@angular/core';
import { NgModule } from '@angular/core';

/**
 * Transforma segundos a formato hora
 */
@Pipe({ name: 'numbertotime' })
export class NumberToTimePipe implements PipeTransform
{
  transform(value: number)
  {
    if(isNaN(value))
      value = 0;

    value = Math.round(value);

    let min = Math.floor(value / 60);
    let sec = value % 60;

    min = (min < 0) ? 0 : min;
    sec = (sec < 0) ? 0 : sec;

    const strMin = ((min < 10) ? '0' : '') + min;
    const strSec = ((sec < 10) ? '0' : '') + sec;

    return strMin + ':' + strSec;
  }
}

@NgModule({
  declarations: [ NumberToTimePipe ],
  imports: [],
  exports: [ NumberToTimePipe ]
})
export class NumberToTimePipeModule {}
